import EducatorInfo from '@Pages/Educator/educator-info/educator-info'

function MedicalInfo() {
    return (
        <>
            <EducatorInfo
                firstBoxTitle="PATIENT INFORMATION"
                secondFirstTitle="PARENT | GUARDIAN | PARTNER"
                addMoreBtnLabel="Add Parent | Guardian | Partner"
                pageType="MEDICAL"
            />
        </>
    )
}

export default MedicalInfo
